// extracted by mini-css-extract-plugin
module.exports = {"footerNav":"ShipmentTrackingNav_footerNav__22njg"};